import { lastData, lastSeen } from '~/helpers/fields-description';
import { NAModule } from '../NAModule.model';

export class NTDC extends NAModule {
    hasOperationDissociate = false;

    get fieldLastSeen() {
        return lastSeen(
            this.last_seen,
            this.outdatedLastSeen ? 'error--text' : '',
        );
    }
    get fieldLastData() {
        return lastData(
            this.last_data,
            this.outdatedLastData ? 'error--text' : '',
        );
    }
}
